(function () {
    "use strict";

    angular.module("app").controller("RequestScreeningsController", RequestScreeningsController);
    RequestScreeningsController.$inject = ["notificationService", "webApiServices", "$filter", "habilBootbox", "enumService",];
    function RequestScreeningsController(notificationService, webApiServices, $filter, habilBootbox, enumService) {
        const context = {
            screeningReports: null,
            translations: $filter("habilTranslation"),
            formatters: {
                kbo: $filter("kboNumber"),
                rr: $filter("rrNumber")
            },
            requestId: ""
        };

        const vm = Object.assign(this, {
            initialize,
            getScreeningReports,
            getDetails,
            getScreeningRowStyle,
            showScreeningHistory,
            isPersonReinvestigation,
        });

        vm.RequestId = null;
        vm.Screenings = [];

        function initialize(requestId) {
            context.requestId = requestId;

            loadScreenings();
        }

        function loadScreenings() {
            webApiServices.GetAllScreeningsForFvmRequest(
                { PublicId: context.requestId },
                (result) => {
                    const screenings = result.data;

                    context.screeningReports = screenings?.flatMap(screening => screening.Attachments?.filter(a => a.TypeCode == enumService.AttachmentTypes.ScreeningResultDocument) ?? []);

                    vm.Screenings = screenings;
                },
                (error) => DoShowError(notificationService, error)
            );
        }

        function getScreeningReports() {
            return Array.isArray(context.screeningReports) ? context.screeningReports : [];
        }

        function getDetails(screening) {
            if (!screening)
                return;

            if (screening.TypeCode == enumService.ScreeningTypeCode.FVM) {
                return screening.OrgName + " (" + context.formatters.kbo(screening.OrgReferenceNbr) + ")";
            }

            return screening.FirstName + " " + screening.Name + " (" + context.formatters.rr(screening.ReferenceNbr) + ")";
        }

        function getScreeningRowStyle(screening) {
            const classes = [];

            if (screening.IsRevision) {
                classes.push("revision");
            }

            const screeningResultCode = Number.parseInt(screening.ResultCode, 10);

            if (screeningResultCode === enumService.ScreeningResultCode.Retour) {
                classes.push("retour");
            } else if (screeningResultCode === enumService.ScreeningResultCode.Report) {
                classes.push("danger");
            } else if (screening.Status >= enumService.ScreeningStatusCode.Completed) {
                classes.push("bg-success");
            }

            return classes.join(" ");
        }

        function showScreeningHistory(screeningId) {
            habilBootbox.alert({
                templateHtml: `<div ng-controller="ScreeningHistoryController"><history-table history="history" subject-id="${screeningId}"></div>`,
                onEscape: true,
                size: "extra-large",
                title: context.translations("Dossier_History")
            });
        }

        function isPersonReinvestigation(screening) {
            return screening.TypeCode === enumService.ScreeningTypeCode.PersonReinvestigation;
        }
    }
})();
